import React, { Fragment, useState } from "react";
import { Form, Col, TimePicker } from "antd";
import moment from "moment";
import _ from "lodash";
import "moment/locale/fr";

const TimeBeginEnd = props => {
  const todayHour = Number(moment().format("HH"));
  const dateSelected =
    props.currentDate !== ""
      ? moment(props.currentDate).format("YYYY-MM-DD")
      : todayHour > 19
      ? moment(
          moment()
            .add(1, "day")
            .format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        )
      : moment().format("YYYY-MM-DD");
  const startTimeHourSelected = moment(props.currentHour).format("HH");
  const todayDate = moment().format("YYYY-MM-DD");
  const todayMinutes = Number(moment().format("mm"));

  const FormItem = Form.Item;

  const roundedUp = Math.ceil(moment().minute() / 15) * 15;

  const nextFifteenMinutes = moment()
    .minute(roundedUp)
    .second(0);

  return (
    <FormItem {...props.formItemLayout} label="Horaire début et fin" required>
      <Col span={12}>
        <Fragment>
          {props.getFieldDecorator("startTime", {
            initialValue: !_.isEmpty(props.eventInfos)
              ? props.updateEventFromCalendarClick
                ? moment(moment(props.eventInfos.start_date).format("HH:mm"), "HH:mm")
                : moment(moment(props.eventInfos.dateEvent).format("HH:mm"), "HH:mm")
              : todayHour > 19 || todayHour < 8
              ? moment(
                  moment(dateSelected)
                    .hour(8)
                    .minute(0)
                    .second(0)
                    .format("HH:mm"),
                  "HH:mm"
                )
              : moment(nextFifteenMinutes.format("HH:mm"), "HH:mm"),
            rules: [
              {
                required: true,
                message: "Horaire début de visite"
              }
            ]
          })(
            <TimePicker
              disabled={props.disabled}
              format={"HH:mm"}
              minuteStep={15}
              onChange={startTime => {
                props.form.setFieldsValue({
                  ["startTime"]: startTime
                });
                props.form.setFieldsValue({
                  ["endTime"]: moment(startTime.format("HH:mm"), "HH:mm").add(45, "minutes")
                });
              }}
              disabledHours={() => {
                if (dateSelected === todayDate) {
                  const disabledHours = [];

                  for (let i = 0; i <= todayHour; i++) {
                    if (i === todayHour && todayMinutes >= 45) disabledHours.push(i);
                    else if (i < todayHour) disabledHours.push(i);
                  }

                  return disabledHours;
                } else return [];
              }}
              disabledMinutes={() => {
                if (dateSelected === todayDate && startTimeHourSelected === todayHour) {
                  const disabledMinutes = [];

                  for (let i = 0; i < 60; i += 15) {
                    if (i < todayMinutes) disabledMinutes.push(i);
                  }
                  return disabledMinutes;
                }
                return [];
              }}
            />
          )}
        </Fragment>
      </Col>
      <Col span={12}>
        <Fragment>
          {props.getFieldDecorator("endTime", {
            initialValue: moment(props.form.getFieldValue("startTime").format("HH:mm"), "HH:mm").add(45, "minutes"),
            rules: [
              {
                required: true,
                message: "Horaire début de visite"
              }
            ]
          })(
            <TimePicker
              disabled={props.disabled}
              onChange={endTime =>
                props.form.setFieldsValue({
                  ["endTime"]: endTime
                })
              }
              format={"HH:mm"}
              minuteStep={15}
              disabledHours={() => {
                const disabledHours = [];
                //suppression des heures avant l'heure du jour si event du jour , sinon suppression des heures avant l'heure de début
                for (
                  let i = 0;
                  i < (todayHour && dateSelected === todayDate) ||
                  i < Number(props.form.getFieldValue("startTime").format("HH"));
                  i++
                ) {
                  disabledHours.push(i);
                }
                return disabledHours;
              }}
            />
          )}
        </Fragment>
      </Col>
    </FormItem>
  );
};

export default TimeBeginEnd;



// WEBPACK FOOTER //
// src/components/planning/FormItems/TimeBeginEnd.js